module.exports = __webpack_public_path__ + "static/media/400080_01.64c3241c.png";